import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import WarehouseForSelect from '../entities/warehouseForSelect'
import Ajax from '../../lib/ajax'

interface WarehouseState extends ListState<WarehouseForSelect>{
     warehousesForSelect: WarehouseForSelect[]
}
class WarehouseModule extends ListModule<WarehouseState,any,WarehouseForSelect>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<WarehouseForSelect>(),
        loading:false,
        warehousesForSelect:new Array<WarehouseForSelect>()
    }
    actions={
        async getListForSelect(context:ActionContext<WarehouseState,any>,payload: any){
            let reponse=await Ajax.get('/api/services/app/Warehouse/GetWarehousesForSelect', { params : payload.data });
            context.state.warehousesForSelect=reponse.data.result.items as WarehouseForSelect[];
        },
        async getAllListForSelect(context:ActionContext<WarehouseState,any>,payload: any){
            let reponse=await Ajax.get('/api/services/app/Warehouse/GetAllWarehousesForSelect', { params : payload.data });
            return reponse.data.result.items as WarehouseForSelect[];
        }
    };
    mutations={
        setCurrentPage(state:WarehouseState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:WarehouseState,pagesize:number){
            state.pageSize=pagesize;
        },
       
    }
}
const warehouseModule=new WarehouseModule();
export default warehouseModule;